// extracted by mini-css-extract-plugin
export default {"card":"SongCard_card__SZi9Q","image":"SongCard_image__ieuT5"};